import { DossierConfigService, SaleService } from "@/services";
import { Observation, ObservationType } from "./carpass/observation";
import { Sale } from "@/models/base";
import { CarpassService } from "@/services/carpass-service";
import { ObservationStatus, ObservationStatusResponse } from "./carpass/observation-status";
import { ObservationStatusIssue } from "./carpass/observation-status-issue";

export class CarpassInputModalState {
	private modalOpen:boolean = false;

	private resolveHandlers:Function[] = [];
	private rejectHandlers:Function[] = [];

	private descriptionModalCloseHandler:Function | null= null;

	public chassis:string = "";
	public mileage:number = 0.0;
	public observationDate:Date = new Date();
	public firstUseDate:Date | null = null;
	public observationType:ObservationType = ObservationType.REPAIR_MAINTENANCE_SERVICE;

	public issues:ObservationStatusIssue[] = [];

	public sale:Sale = new Sale();

	public isSaving:boolean = false;

	private observationDescriptionModalOpen:boolean = false;

	public isModalOpen():boolean {
		return this.modalOpen;
	}

	public isDescriptionModalOpen():boolean {
		return this.observationDescriptionModalOpen;
	}

	private shouldShowCarpassModalInSaleEdit(sale:Sale):boolean {
		if (sale.TypeID != 1) return false;
		if (!sale.Car) return false;
		if (!sale.Car.UseInCarpass) return false;
		if (!DossierConfigService.getCarpassConfig().isConfigured()) return false;
		return true;
	}

	async showCarpassModalIfRequiredFromSaleEdit(sale:Sale){
		if (!sale.Car) return;
		if (!sale.Contact) return;
		if (!this.shouldShowCarpassModalInSaleEdit(sale)) return;
		this.sale = sale;
		this.chassis = sale.Car.Chassis;
		this.mileage = sale.Car.Mileage;
		this.observationDate = sale.InvoiceDate;
		this.firstUseDate = sale.Car.CommDate;

		return new Promise((resolve, reject)=>{
			this.modalOpen = true;
			this.resolveHandlers.push(resolve);
			this.rejectHandlers.push(reject);
		});
	}

	async showCarpassModalForCorrection(sale:Sale, observation:ObservationStatusResponse) {
		if (!observation.Issues) return;
		this.sale = sale;
		this.issues = observation.Issues;

		if (this.sale.CarpassObservationBody) {
			this.chassis = this.sale.CarpassObservationBody.vin;
			this.mileage = this.sale.CarpassObservationBody.odometerReading;
			this.observationDate = this.sale.CarpassObservationBody.odometerReadingDate;
			this.firstUseDate = this.sale.CarpassObservationBody.firstUseDate;
			this.observationType = this.sale.CarpassObservationBody.observationType;
		}

		return new Promise((resolve, reject)=>{
			this.modalOpen = true;
			this.resolveHandlers.push(resolve);
			this.rejectHandlers.push(reject);
		});
	}

	async openDescriptionModal(){
		if (this.observationDescriptionModalOpen) return;
		this.observationDescriptionModalOpen = true;
		return new Promise((resolve)=>{
			this.descriptionModalCloseHandler = resolve;
		});
	}

	saveDisabled():boolean{
		if (this.isSaving){
			return true;
		}

		if (this.sale.CarpassObservationBody == null){
			return false;
		}
		if (this.sale.CarpassObservationBody.isSame(this.createObservation())){
			return true;
		}
		return false;
	}

	closeDescriptionModal(){
		this.observationDescriptionModalOpen = false;
		if (!this.descriptionModalCloseHandler) return;
		this.descriptionModalCloseHandler();
	}

	cancel(){
		for (let handler of this.rejectHandlers){
			handler();
		}
		this.clearHandlers();
		this.modalOpen = false;
	}

	private  createObservation():Observation {
		let observation = new Observation();
		observation.vin = this.chassis;
		observation.odometerReading = this.mileage;
		observation.odometerReadingDate = this.observationDate;
		observation.firstUseDate = this.firstUseDate;
		observation.observationType = this.observationType;
		observation.enteredOrganisation = DossierConfigService.getCarpassConfig().Username;
		observation.enterpriseOrganisation = DossierConfigService.getCarpassConfig().KboNumber;
		return observation;
	}

	async confirm(){
		if (this.saveDisabled()) return;
		this.isSaving = true;
		try{
			let observation = this.createObservation();
			if (this.sale.CarpassRequestId) {
				var response = await CarpassService.postObservationCorrection(this.sale, observation);
			}else{
				var response = await CarpassService.postObservation(this.sale, observation);
			}
			if (response.Status == ObservationStatus.ERROR || response.Status == ObservationStatus.ISSUE) {
				this.issues = response.Issues;
				this.sale = await SaleService.getSale(this.sale.ID);
				return;
			}
			if(response.Status == ObservationStatus.PROCESSED) {
				this.sale = await SaleService.getSale(this.sale.ID);
				await this.openDescriptionModal();
			}
			for (let handler of this.resolveHandlers){
				handler();
			}
			this.clearHandlers();
			this.modalOpen = false;
		}catch(err){

		}finally{

			this.isSaving = false;
		}
	}

	private clearHandlers(){
		this.rejectHandlers.splice(0, this.rejectHandlers.length);
		this.resolveHandlers.splice(0, this.resolveHandlers.length);
	}

}
